import { motion } from 'framer-motion';

export const Footer = () => {
  const handleHomeClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-8 border-t border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center md:justify-start gap-6 mb-6 md:mb-0">
            <a 
              href="/" 
              onClick={handleHomeClick}
              className="nav-link text-gray-300 hover:text-cyan-400 transition-colors"
            >
              Home
            </a>
            <a href="#services" className="nav-link text-gray-300 hover:text-cyan-400 transition-colors">Services</a>
            <a href="#about" className="nav-link text-gray-300 hover:text-cyan-400 transition-colors">About Us</a>
            <a href="#contact" className="nav-link text-gray-300 hover:text-cyan-400 transition-colors">Contact</a>
          </div>
        </div>
        
        {/* Copyright and Binary Text */}
        <div className="mt-8 text-center">
          <div className="text-gray-400 mb-4">
            Copyright © HyperMesh AI 2025
          </div>
          <div className="text-xs text-gray-600 font-mono overflow-hidden whitespace-nowrap binary-scroll">
            {Array(50).fill('01').join(' ')}
          </div>
        </div>
      </div>
    </footer>
  );
};